export const sendRefund = (id, payment_id, amount, method) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();
    // Remove This Line Before Deployment
    // firebase.functions().useEmulator("localhost", 5001);
    const requestRef = firestore.collection("testNewRequests").doc(id);
    const currentTime = firebase.firestore.Timestamp.fromDate(new Date());
    const paymentRefund = firebase.functions().httpsCallable("refundInitiate");
    const batch = firestore.batch();
    const toFirestore = {
      paymentDone: false,
      refund: true,
      modifiedAt: currentTime,
    };

    batch.set(requestRef, toFirestore, { merge: true });
    dispatch({ type: "REFUND_HAPPENING" });
    paymentRefund({ id, payment_id, amount, method })
      .then((response) => {
        console.log(response.data);
        if (
          !response.data.hasOwnProperty("error") &&
          response.data.response_code === "100"
        ) {
          batch.commit().then(() => {
            dispatch({ type: "REFUND_DONE" });
            dispatch({ type: "REFUND_CLEAR_STATUS" });
          });
        } else {
          dispatch({
            type: "REFUND_ERROR",
            err: `ERROR ${response.data.response} : ${response.data.responsetext}`,
          });
        }
      })
      .catch((e) => {
        console.log(e);
        dispatch({ type: "REFUND_ERROR", err: "Something went wrong." });
      });
  };
};
